import { render } from "./DefaultLayout.vue?vue&type=template&id=28b93250&scoped=true"
const script = {}

import "./DefaultLayout.vue?vue&type=style&index=0&id=28b93250&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28b93250"]])

export default __exports__